<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8"> <!-- Filter Section -->
          <div v-if="showFilterSection" class="filter-section"> 
            <b-row class="filter-row">
              <b-col lg="3">
                <label class="some-label" for="select-building">{{ translate('selectMethod') }}</label>
                <b-form-select id="draw-type" v-model="drawOption" @change="resetEkubType">
                  <option v-for="option in selectDrawOption" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col lg="3">
                <label class="some-label" for="select-building">{{ translate('spinOrAssignFor') }}</label>
                <b-form-select id="draw-type" v-model="drawType" @change="resetEkubType">
                  <option v-for="option in drawOptions" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col lg="3" v-if="drawType === 'Individual'">
                <label class="some-label" for="select-status">{{ translate('association') }}</label>
                <b-form-select v-model="ekubType" id="ekub-type" @change="callForWinningManualyForIndividual">
                  <option v-for="option in ekubOptions" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col lg="3" v-if="drawType === 'Individual' && drawOption === 'Manualy'">
                <label class="some-label" for="select-status">{{ translate('member') }}</label>
                <b-form-select v-model="memberOfAssociation" id="member-of-association">
                  <option v-for="option in memberOptions" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col lg="3" v-if="drawType === 'Group'">
                <label class="some-label" for="select-status">{{ translate('amount') }}</label>
                <input v-model.number="totalAmountForDrawing" id="total-amount-for-drawing" type="number" :placeholder="translate('enterTheAmount')" min="1">
              </b-col>
              <b-col lg="3" v-if="drawType === 'Group' && drawOption === 'Manualy'">
                <label class="some-label" for="select-status">{{ translate('selectAssociation') }}</label>
                <b-form-select v-model="selectedAssociationForGroup" id="selected-association-for-group">
                  <option v-for="option in groupEkubOptionsForManula" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col lg="3" v-if="drawType === 'Group' && drawOption === 'Drawing'">
                <label class="some-label" for="select-status">{{ translate('nameOrUniqueId') }}</label>
                <b-form-select v-model="selectViewOption" id="selected-association-for-group">
                  <option v-for="option in selectViewOptions" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col lg="2" class="mt-1" v-if="drawOption === 'Drawing'">
                <b-button class="btn-secondary" id="datepicker-btn" @click="filterDrawingUsingEkubTypeId" :disabled="isFindButtonDisabled">{{ translate('find') }}</b-button>
              </b-col>
              <b-col lg="2" class="mt-1" v-if="drawOption === 'Manualy'">
                <b-button class="btn-secondary" id="datepicker-btn" @click="submitAddForm" :disabled="isFindButtonDisabled">{{ translate('giveEqub') }}</b-button>
              </b-col>
              <b-col lg="2" class="mt-1">
                <b-button class="btn-danger" @click="closeWinnerOverlay">{{ translate('Close') }}</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="col-lg-4 text-right"> <!-- Button to Show Filter Section -->
          <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button v-if="modulePermission.create == 1" @click="showFilterSection = true" class="btn-outline-primary">
                <b-icon class="text-center" icon="plus"></b-icon> {{ translate('Spinning') }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="row mt-3 " style="height: 80vh;" >
        <div :class="isFullScreen ? 'col-lg-12' : 'col-lg-8'"> <!-- Responsive Full-Screen Logic -->
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <b-row>
                <b-col lg="4">
                  <label class="some-label" for="select-building">{{ translate('selectWinnerType') }}</label>
                  <b-form-select id="draw-type" v-model="associationType" @change="resetEkubType">
                    <option v-for="option in associationTypeOption" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </b-form-select>
                </b-col>
                <b-col lg="4" v-if="associationType === 'Individual'">
                  <label class="some-label" for="select-building">{{ translate('association') }}</label>
                  <b-form-select id="select-building" v-model="selectedAssociationType" :options="assocationTypeOptions"></b-form-select>
                </b-col>
                <b-col lg="4" class="mt-4">
                  <b-button class="btn-secondary" id="datepicker-btn" @click="getWinningList()">{{ translate('find') }}</b-button>
                </b-col>
              </b-row>
            </template>
            <div class="table-container">
              <b-table-simple :small="true" sticky-header style="max-height: 395px;" striped responsive hover>
                <b-thead class="sticky-header">
                  <b-tr>
                    <b-th>{{ translate('no') }}</b-th>
                    <b-th>{{ translate('takerName') }}</b-th>
                    <b-th>{{ translate('phoneNumber') }}</b-th>
                    <b-th>{{ translate('nameOfAssociation') }}</b-th>
                    <b-th>{{ translate('uniqueId') }}</b-th>
                    <b-th>{{ translate('amount') }}</b-th>
                    <b-th>{{ translate('status') }}</b-th>
                    <b-th>{{ translate('createdAt') }}</b-th>
                    <b-th>{{ translate('createdBy') }}</b-th>
                    <b-th sticky-column style="height: 45px;"></b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                  <b-tbody class="text-center">
                    <b-tr>
                      <b-td colspan="9" class="text-center" style="display: table-cell">
                        <b-spinner style="height: 3rem; width: 3rem;" variant="warning"></b-spinner>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                    <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="9" class="text-center">Nothing found</b-td>
                      </b-tr>
                    </template>
                    <template v-else>
                      <b-tr v-for="(item, index) in filterTable" :key="item.ID">
                        <b-td>{{ (currentPage - 1) * perPage + index + 1 }}</b-td>
                        <b-td>{{ item.takerName }}</b-td>
                        <b-td>{{ item.phoneNumber }}</b-td>
                        <b-td>{{ item.name }}</b-td>
                        <b-td>{{ item.uniqueId }}</b-td>
                        <b-td>{{ item.amount }}</b-td>
                        <b-td>{{ item.status }}</b-td>
                        <b-td>{{ item.date }}</b-td>
                        <b-td>{{ item.registeredBy }}</b-td>
                        <b-td sticky-column>
                          <b-row>
                            <!-- Additional actions can be added here -->
                          </b-row>
                        </b-td>
                      </b-tr>
                    </template>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
            <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  />
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
          </card>
        </div>
        <div  class="col-lg-4" v-show="!isFullScreen">
          <div class="wheel-section">
            <canvas ref="wheelCanvas" class="wheel-canvas" width="420" height="420"></canvas>
            
            <button v-if="items.length > 0" @click="spinWheel" :disabled="spinning" class="spin-button">
              {{ translate('spin').toUpperCase() }}
            </button>
          </div>

          <!-- Winner Overlay -->
          <div class="winner-overlay" v-if="showWinnerOverlay">
            <div class="winner-message">
              <h2>Congratulations!</h2>
              <p>{{ winnerMessage }}</p>
              <button @click="closeWinnerOverlay" class="close">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import Vinput from 'src/components/Inputs/Vinput.vue'
    import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
    import Vselect from 'src/components/Inputs/Vselect.vue'
    import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        Card,
        Vinput,
        VinputNumber,
        Vselect,
        VinputGroup
      },
      data () {
        return {
        isFullScreen: true, 
        items: [], // Start with an empty array for items
        userInput: '',
        angle: 0,
        spinning: false,
        selectedItem: null,
        showWinnerOverlay: false,
        winnerMessage: '', // To hold the winner's message from the API
        showFilterModal: false, // Controls the visibility of the filter modal
        showSpinningOverlay: false, // Controls the visibility of the spinning overlay
        spinSound: new Audio(require('@/assets/sound/drawingSound-[AudioTrimmer.com].mp3')),
        winnerSound: new Audio(require('@/assets/sound/winningSound.mp3')),
          file: null,
          loading: false, // New loading state
          file: null,
          selectedFile: null,  // Holds the file selected by the user
          fileSelected: false, // Tracks if a file has been selected
          modulePermission: {
            view: 1,
            create: 0,
            update: 0,
            delete: 0
          },
          totalRows: 0,
          currentPage: 1,
          perPage: 7,
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          items: [],
          getItems: [],
          associationTypeOption: [
          { value: 'Individual', label: translate('individuals')},
          { value: 'Group', label: translate('associations') },
          ],
          selectViewOptions: [
          { value: 'Name', label: translate('name')},
          { value: 'UniqueId', label: translate('uniqueId') },
          ],
          assocationTypeOptions: [
            {text: translate('all'), value: "All"},
          ],
          selectedAssociationType: "All",
          selectViewOption:"UniqueId",
          associationType: "",
          filter: "",
          spinner: true,
          showFilterSection: false, // Controls visibility of the filter section
        drawOption: null,
        drawType: null,
        ekubType: null,
        memberOfAssociation: null,
        totalAmountForDrawing: null,
        selectedAssociationForGroup: null,
        selectDrawOption: [{value: 'Manualy', label: translate('manual')}, {value: 'Drawing', label: translate('spin')}],
        drawOptions: [{value: 'Individual', label: translate('individual')}, {value: 'Group', label: translate('forAssociation')}],
        ekubOptions: [],
        memberOptions:[],
        groupEkubOptionsForManula: [],
        isFindButtonDisabled: false,
        }
      },
      computed: {
        paginatedItems() {
    if (this.currentView === 'full') {
      return this.fullItems.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
    } else {
      return this.spinningItems.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
    }
  },
  totalRows() {
    return this.currentView === 'full' ? this.fullItems.length : this.spinningItems.length;
  },
        isFindButtonDisabled() {
      // Ensure that the button is only enabled if all required filters are set
      if (this.drawType === 'Individual') {
        return !this.ekubType;  // Button disabled if no Ekub Type selected
      } else if (this.drawType === 'Group') {
        return this.totalAmountForDrawing <= 0;  // Button disabled if number of Ekub is not valid
      }
      return true; // Button disabled by default if no draw type is selected
    },
        filterTable() {
          var searchItems = this.getItems;
          var searchString = this.filter;
          if (searchString === "") {
            return searchItems;
          }
          searchString = searchString.trim().toLowerCase();
  
          searchItems = searchItems.filter(function (item) {
            if (item.fullName.toLowerCase().indexOf(searchString) !== -1 ||  item.phoneNumber.toLowerCase().indexOf(searchString) !== -1 || item.email.toLowerCase().indexOf(searchString) !== -1 || item.address.toLowerCase().indexOf(searchString) !== -1 ) {
              return item;
            }
          });
          return searchItems;
        },
      },
       mounted() {
        this.getWinningList();
        this.callForWinningManualyForGroup();
        this.getEkubType2();
        this.getModules();
        this.$on("AfterComplete", () => {
          this.getWinningList();
          this.callForWinningManualyForGroup();
          this.getEkubType2();
        });
      },
      methods: {
        translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
         getModules(){
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
            .then(response=>{
                //this.items = response.data;
                var modulesList = response.data.modules;
                var CustomerModule = modulesList.filter(x=>x.name === "Members_Super");
                if(CustomerModule !== null){
                  this.modulePermission.view = CustomerModule[0].listData;
                  this.modulePermission.create = CustomerModule[0].createData;
                  this.modulePermission.update = CustomerModule[0].updateData;
                  this.modulePermission.delete = CustomerModule[0].deleteData;
                }
            })
            .catch(error=>{
                //console.log(error);
            })
        },
        getEkubType2(){
           this.$store.dispatch('getAllAssociationForDrawingOfIndvidual',{userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
          .then(response=>{
              Array.from(response.data).forEach((value) => {
              this.assocationTypeOptions.push({
                value: value.ekubTypeId,
                text: value.ekubTypeName
              });
            });
          })
          .catch(error=>{
              this.$notify({
                  title: 'Error',
                  text: error.response.data,
                  type: 'error'
              })
          })
        },
        getWinningList(){
          this.spinner = true;
          if(this.associationType===""&&this.selectedAssociationType===""){
            this.$store.dispatch('getWinningListGroup', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                // console.log("log ",response.data);
              this.getItems = response.data.Contents;
              this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        }
        else if(this.associationType==="Individual"&&this.selectedAssociationType==="All"){
            this.$store.dispatch('getWinningListIndividual', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                // console.log("log ",response.data);
              this.getItems = response.data.Contents;
              this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        }
        else if(this.associationType==="Individual"&&this.selectedAssociationType!=="All"){
            this.$store.dispatch('getWinningListIndividual', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage, ekubTypeId: this.selectedAssociationType})
            .then(response=>{
                // console.log("log ",response.data);
              this.getItems = response.data.Contents;
              this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        }
        else{
            this.$store.dispatch('getWinningListGroup', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                // console.log("log ",response.data);
              this.getItems = response.data.Contents;
              this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        }
        },
        changePage(event, page){
          this.spinner = true;
          if(this.associationType===""&&this.selectedAssociationType===""){
          this.$store.dispatch('getWinningListGroup', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else if(this.associationType==="Individual"&&this.selectedAssociationType==="All"){
            this.$store.dispatch('getWinningListIndividual', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else if(this.associationType==="Individual"&&this.selectedAssociationType!=="All"){
            this.$store.dispatch('getWinningListIndividual', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage, ekubTypeId: this.selectedAssociationType})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.$store.dispatch('getWinningListGroup', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        },
        changePerPage(event){
          this.spinner = true;
          if(this.associationType===""&&this.selectedAssociationType===""){
          this.$store.dispatch('getWinningListGroup', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else if(this.associationType==="Individual"&&this.selectedAssociationType==="All"){
            this.$store.dispatch('getWinningListIndividual', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else if(this.associationType==="Individual"&&this.selectedAssociationType!=="All"){
            this.$store.dispatch('getWinningListIndividual', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage, ekubTypeId: this.selectedAssociationType})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.$store.dispatch('getWinningListGroup', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.getItems = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        },
              // Fetch Ekub Types by user ID and update the ekubOptions array
      getEkubType() {
        const userId = sessionStorage.getItem("ID");
        const superUserId = parseInt(sessionStorage.getItem("superID"));
        if (!userId || isNaN(superUserId)) {
          this.$notify({
            title: 'Invalid Session Data',
            text: 'Session data for userId or superUserId is missing or invalid.',
            type: 'danger'
          });
          return;
        }
        // Dispatch the action to get Ekub types from the store
        this.$store.dispatch('getAllAssociationForDrawingOfIndvidual', { userId, superUserId })
          .then(response => {
            if (response.data && Array.isArray(response.data)) {
              this.ekubOptions = response.data.map((value) => ({
                value: value.ekubTypeId,
                label: value.ekubTypeName
              }));
            } else {
              this.$notify({
                title: 'No Ekub Types Found',
                text: 'The API returned no Ekub types.',
                type: 'warning'
              });
            }
          })
          .catch(error => {
            console.error('API Error:', error);
            this.$notify({
              title: error.response,
              text: error.response ? error.response.data : 'An unexpected error occurred.',
              type: 'danger'
            });
          });
          },
        callForWinningManualyForIndividual() {
        const userId = sessionStorage.getItem("ID");
        const superUserId = parseInt(sessionStorage.getItem("superID"));
        if (!userId || isNaN(superUserId)) {
          this.$notify({
            title: 'Invalid Session Data',
            text: 'Session data for userId or superUserId is missing or invalid.',
            type: 'danger',
          });
          return;
        }

        const ekubTypeId = this.ekubType;
        if (!ekubTypeId) {
          this.$notify({
            title: 'No Association Selected',
            text: 'Please select an association before proceeding.',
            type: 'warning',
          });
          return;
        }

        this.$store
          .dispatch('callForWinningManualyForIndividual', { userId, superUserId, ekubTypeId })
          .then((response) => {
            if (response.data && Array.isArray(response.data)) {
              this.itemsDataManualyIndividual = response.data; // Store raw data
              // this.memberOptions = response.data.map((value) => ({
              //   value: value.ekubJoinerId,
              //   label: value.fullName
              // }));
              // Filter out any null or undefined members
              this.memberOptions = response.data
                .filter((value) => value.ekubJoinerId && value.fullName) // Filter out invalid data
                .map((value) => ({
                  value: value.ekubJoinerId,
                  label: value.fullName,
                }));
            } else {
              this.$notify({
                title: 'No Members Found',
                text: 'The API returned no members or an invalid response.',
                type: 'warning',
              });
            }
          })
          .catch((error) => {
            console.error('API Error:', error);
            this.$notify({
              title: 'API Error',
              text: error.response ? error.data : 'An unexpected error occurred.',
              type: 'danger',
            });
          });
      },
callForWinningManualyForGroup() {
  const userId = sessionStorage.getItem("ID");
  const superUserId = parseInt(sessionStorage.getItem("superID"));
  if (!userId || isNaN(superUserId)) {
    this.$notify({
      title: 'Invalid Session Data',
      text: 'Session data for userId or superUserId is missing or invalid.',
      type: 'danger',
    });
    return;
  }

  this.$store
    .dispatch('filterDrawingUsingForGroupForManual', { userId, superUserId })
    .then((response) => {
      if (response.data && Array.isArray(response.data)) {
        // this.itemsDataManualyIndividual = response.data; // Store raw data
        this.groupEkubOptionsForManula = response.data
          .filter((value) => value.ekubTypeId && value.ekubTypeName) // Filter out invalid data
          .map((value) => ({
            value: value.ekubTypeId,
            label: value.ekubTypeName,
          }));
      } else {
        this.$notify({
          title: 'No Members Found',
          text: 'The API returned no members or an invalid response.',
          type: 'warning',
        });
      }
    })
    .catch((error) => {
      console.error('API Error:', error);
      this.$notify({
        title: error.data,
        text: error.response ? error.data : 'An unexpected error occurred.',
        type: 'danger',
      });
    });
},
   filterDrawingUsingEkubTypeId() {
    this.items = [];  // Clear previous items
    this.itemsData = []; // Store the raw response data
    // Validate Ekub Type for individuals
    if (this.drawType === 'Individual' && this.ekubType) {
        const requestBody = {
            ekubTypeId: this.ekubType,
            userId: sessionStorage.getItem("ID"),
            superUserId: parseInt(sessionStorage.getItem("superID")),
        };

        this.$store.dispatch('filterDrawingUsingEkubTypeId', requestBody)
            .then(response => {
                if (response.data && response.data.length > 0) {
                    this.itemsData = response.data; // Store raw data
                    // console.log("itemsData ",this.itemsData);
                    // Make sure to use the correct property for member names
                    this.items = response.data.map(entry => entry.fullName); // Extract names
                    this.isFullScreen = false;
                    this.drawWheel();  // Draw the wheel with the new data
                } else {
                    this.$notify({
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        title: 'No Data Found',
                        text: 'No members found for the selected Ekub Type.',
                        type: 'danger',
                    });
                }
            })
            .catch(error => {
                console.error('API Error:', error); // Log error for debugging
                this.$notify({
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    title: error.data,
                    text: error.response  ? error.response.data : 'An unexpected error occurred.',
                    type: 'danger',
                });
            });
    }
    // Handle "Group" case
    else if (this.drawType === 'Group' && this.totalAmountForDrawing > 0) {
      this.groupEkubType = null;
      const requestBody = {
        totalAmountForDrawing: this.totalAmountForDrawing,
        userId: sessionStorage.getItem("ID"),
        superUserId: parseInt(sessionStorage.getItem("superID")),
      };
      this.$store.dispatch('filterDrawingUsingForGroup', requestBody)
    .then(response => {
      // console.log("API Response: ", response.data); // Debugging line
      if (response.data && Array.isArray(response.data)) {
        // Store raw response data
        this.itemsDataGroup = response.data; 
        // Map response data to include both ekubTypeName and uniqueId
        this.items = response.data.map(entry => ({
          ekubTypeId: entry.ekubTypeId,      // New field
          uniqueId: entry.uniqueId,            // New field
          ekubTypeName: entry.ekubTypeName,   // Ensure this field is available
          ekubAmount: entry.ekubAmount,        // New field for amount
          numberOfEkuber: entry.numberOfEkuber  // New field for number of Ekuber
        }));
        // console.log("Mapped Items: ", this.items); // Debugging line
        this.groupEkubType = response.data[0].ekubTypeId || null; // Store the selected EkubTypeId
        this.isFullScreen = false; // Update UI state
        this.drawWheel();  // Draw the wheel with the new data
      } else {
        this.$notify({
          horizontalAlign: 'center',
          verticalAlign: 'top',
          title: 'No Data Found',
          text: 'No group data found for the selected number of Ekub.',
          type: 'danger',
        });
      }
    })
    .catch(error => {
      console.error('API Error:', error); // Log error for debugging
      this.$notify({
        horizontalAlign: 'center',
        verticalAlign: 'top',
        title: error.data,
        text: error.response ? error.response.data : 'An unexpected error occurred.',
        type: 'danger',
      });
    });
    } else {
      this.$notify({
        title: 'Invalid Filter',
        text: 'Please select a valid filter option.',
        type: 'danger',
      });
    }
  },
resetEkubType() {
        if (this.drawType !== 'Individual') {
          this.ekubType = null;
        }else if (this.drawType === 'Group') {
        this.groupEkubType = null;
        this.totalAmountForDrawing = null;
        this.getEkubType();
        } else {
          this.getEkubType();
        }
      },
      // Draw the wheel based on the items
      drawWheel() {
  const canvas = this.$refs.wheelCanvas;
  const ctx = canvas.getContext('2d');
  const radius = canvas.width / 2;
  const numItems = this.items.length;
  const anglePerItem = (2 * Math.PI) / numItems;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const colors = [];
  for (let i = 0; i < numItems; i++) {
    let newColor;
    do {
      newColor = getRandomColor();
    } while (i > 0 && colors[i - 1] === newColor);
    colors.push(newColor);
  }

  for (let i = 0; i < numItems; i++) {
    const startAngle = i * anglePerItem;
    const endAngle = startAngle + anglePerItem;
    ctx.fillStyle = colors[i];
    ctx.beginPath();
    ctx.moveTo(radius, radius);
    ctx.arc(radius, radius, radius, startAngle, endAngle);
    ctx.closePath();
    ctx.fill();
 // Determine the label based on the selected view option and action type
    let label;
    if (this.drawType === 'Individual') {
      label = this.itemsData[i].fullName; // Use fullName for Individuals
    } else if (this.drawType === 'Group') {
      label = this.selectViewOption === 'Name' 
        ? this.items[i].ekubTypeName // Use ekubTypeName for 'Name'
        : this.items[i].uniqueId; // Use uniqueId for 'UniqueId'
    }
    ctx.fillStyle = '#333333';
    ctx.font = 'bold 12px Arial';
    ctx.textAlign = 'center';

    const labelX = radius + Math.cos(startAngle + anglePerItem / 2) * (radius * 0.7);
    const labelY = radius + Math.sin(startAngle + anglePerItem / 2) * (radius * 0.7);

    ctx.save();
    ctx.translate(labelX, labelY);
    ctx.rotate(Math.atan2(labelY - radius, labelX - radius));
    ctx.fillText(label, 0, 0);
    ctx.restore();
  }
},
   spinWheel() {
    if (this.spinning) return;

    if (!this.items.length) {
      alert("There are no items to spin. Please add items to the wheel.");
      return;
    }

    this.spinning = true;
    const randomSpinAngle = Math.random() * 5000 + 5000;
    const canvas = this.$refs.wheelCanvas;
    canvas.style.transition = 'transform 5s ease-out';
    canvas.style.transform = `rotate(${this.angle + randomSpinAngle}deg)`;
    this.spinSound.play();

    const finalAngle = (this.angle + randomSpinAngle) % 360;
    const sectionAngle = 360 / this.items.length;
    const selectedIndex = Math.floor((finalAngle + sectionAngle / 2) / sectionAngle) % this.items.length;

    const selectedItem = this.items[selectedIndex];

    setTimeout(() => {
      if (this.drawType === 'Individual') {
        let ekubJoinerId;
        if(this.drawOption === 'Drawing'){
        ekubJoinerId = this.getEkubJoinerId(selectedItem); // Retrieve ekubJoinerId
        }
        else{
        ekubJoinerId  = this.getEkubJoinerIdForManualy(selectedItem);
        }
        if (ekubJoinerId) {
          this.callWinnerAPI(selectedItem, ekubJoinerId, 'callForWinningForIndividual');
        } else {
          this.$notify({
            title: 'Error',
            text: 'Failed to retrieve Ekub Joiner ID.',
            type: 'danger',
          });
        }
      } else if (this.drawType === 'Group') {
        const ekubTypeId = this.getEkubTypeId(selectedItem); // Retrieve ekubTypeId
        // console.log("ekubTypeId ",ekubTypeId);
        if (ekubTypeId) {
          this.callWinnerAPI(selectedItem, ekubTypeId, 'callForWinningForGroup');
        } else {
          console.log("Errorrrrrrrrrrrrrrrrrr");
          this.$notify({
            title: 'Error',
            text: 'Failed to retrieve Ekub Type ID.',
            type: 'danger',
          });
        }
      } else {
        this.$notify({
          title: 'Error',
          text: 'Invalid draw type selected.',
          type: 'danger',
        });
      }

      this.spinning = false;
    }, 5000);

    this.angle += randomSpinAngle;
  },
  getEkubJoinerId(selectedItem) {
    const responseItem = this.itemsData.find(item => item.fullName === selectedItem);
    return responseItem ? responseItem.ekubJoinerId : null;
  },
  getEkubJoinerIdForManualy(selectedItem) {
    const responseItem = this.itemsDataManualyIndividual.find(item => item.fullName === selectedItem);
    return responseItem ? responseItem.ekubJoinerId : null;
  },
  // Get the ekubTypeId for the selected group
  getEkubTypeId(selectedItem) {
    const responseItem = this.itemsDataGroup.find(item => item.ekubTypeName === selectedItem.ekubTypeName);
    return responseItem ? responseItem.ekubTypeId : null;
  },
  callWinnerAPI(selectedItem, id, apiMethod) {
  const requestBody = {
    userId: sessionStorage.getItem("ID"),
    registeredBy: parseInt(sessionStorage.getItem("userID")),
    superUserId: parseInt(sessionStorage.getItem("superID")),
  };

  if (apiMethod === 'callForWinningForIndividual') {
    requestBody.ekubJoinerId = id;
    requestBody.ekubTypeId = this.ekubType;
  } else if (apiMethod === 'callForWinningForGroup') {
    requestBody.ekubTypeId = id;
    requestBody.totalAmountForDrawing = this.totalAmountForDrawing;
  }
  this.$store.dispatch(apiMethod, requestBody)
    .then(response => {
      if (response.data && response.data.length > 0) {
        if(apiMethod === 'callForWinningForIndividual'){
          this.winnerMessage = response.data.message || `The Winner: ${selectedItem}`;
        }
        else{
          this.winnerMessage = response.data.message || `The Winner: ${selectedItem.ekubTypeName}`;
        }
        this.showWinnerOverlay = true; // Show the winner overlay
        this.winnerSound.play(); // Play winner sound
      } else {
        this.$notify({
          title: 'No Data Found',
          text: `No winner found for the selected ${apiMethod === 'callForWinningForIndividual' ? 'Individual' : 'Group'}.`,
          type: 'info',
        });
      }
    })
    .catch(error => {
      this.$notify({
        horizontalAlign: 'center',
        verticalAlign: 'top',
        message: error.data,
        title: error.response,
        text: error.data ? error.response.data : 'An unexpected error occurred.',
        type: 'danger',
      });
      setTimeout(() => {
            window.location.reload();
            }, 1000); // Adjust delay as needed
    });
},
    closeWinnerOverlay() {
    this.showWinnerOverlay = false;
    this.resetModule();
    window.location.reload();  // This will reload the page
  },
  resetModule() {
    this.drawType = '';       // Clear draw type
    this.ekubType = null;     // Clear Ekub type selection
    this.groupEkubType = null;
    this.totalAmountForDrawing = null;  // Default number of Ekub for Group
    this.items = [];          // Clear filtered items
    this.angle = 0;           // Reset wheel angle
    this.spinning = false;    // Reset spinning flag
    this.selectedItem = null; // Clear selected item
    this.showWinnerOverlay = false;  // Hide winner overlay
    
  },
  submitAddForm() {
    this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
        title: translate('confirm'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle:  translate('yes'),
        cancelTitle: translate('nono'),
        bodyClass: 'm-2',
        hideHeaderClose: false,
        centered: false
    })
    .then(value => {
        if (value === true) {
            if (this.drawType === 'Individual' && this.drawOption === 'Manualy') {
                var submitForm = {
                    registeredBy: sessionStorage.getItem("userID"),
                    superUserId: parseInt(sessionStorage.getItem("superID")),
                    userId: sessionStorage.getItem("ID"),
                    ekubJoinerId: this.memberOfAssociation,
                    ekubTypeId: this.ekubType,
                };
                this.$store.dispatch('callForWinningForIndividual', submitForm)
                    .then(response => {
                        // console.log('response ', response.data);
                        // console.log('submitForm ', submitForm);
                        this.$notifications.notify({
                            message: `<span>The ekub is successfully submited.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                        });
                        this.$bvModal.hide('modal-top-add');
                        this.clearData();
                        window.location.reload(); // Refresh the window after success
                    })
                    .catch(error => {
                        this.$notifications.notify({
                            message: error.data,
                            // title: error.data,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            // text: error.data,
                            type: 'danger'
                        });
                        setTimeout(() => {
                      window.location.reload();
                      }, 1000); // Adjust delay as needed
                    });
            } else if (this.drawType === 'Group' && this.drawOption === 'Manualy') {
                var submitForm = {
                    registeredBy: sessionStorage.getItem("userID"),
                    superUserId: parseInt(sessionStorage.getItem("superID")),
                    userId: sessionStorage.getItem("ID"),
                    ekubTypeId: this.selectedAssociationForGroup,
                    totalAmountForDrawing: this.totalAmountForDrawing
                };
                this.$store.dispatch('callForWinningForGroup', submitForm)
                    .then(response => {
                        this.$notifications.notify({
                            message: `<span>The ekub is successfully submited.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                        });
                        this.$bvModal.hide('modal-top-add');
                        this.clearData();
                        window.location.reload(); // Refresh the window after success
                    })
                    .catch(error => {
                        this.$notifications.notify({
                            message: error.data,
                            // title: error.data,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            // text: error.data,
                            type: 'danger'
                        });
                        setTimeout(() => {
                      window.location.reload();
                      }, 1000); // Adjust delay as needed
                    });
            } else {
                // Other logic if needed
            }
        }
    })
    .catch(error => {
        // Handle modal cancel or error
    });
},
        clearData(){
          this.associationType = "";
          this.associationTypeOption ="";
          this.$refs.fileInput && this.$refs.fileInput.reset();
          this.$emit('AfterComplete');
        },
      closeModal() {
      this.$bvModal.hide('modal-top-add-bulk');
      this.clearData();
    },
      }
    }
  </script>
  <style lang="scss" scoped>
  .b-table-sticky-column:last-child {
      right: 0;
    }
  .text-warning {
      color: rgba(240, 206, 13, 0.937) !important;
    }
  .btn-icon{
    font-size: 27px !important;
    padding: 3px 5px 3px 5px;
    width: 40px;
    color:  rgb(37, 91, 48);
    border: 2px solid rgb(37, 91, 48);
  }
  .btn-icon:hover,
  .btn-icon:focus {
    cursor: pointer;
    background-color: rgb(37, 91, 48) !important;
    color: rgba(240, 206, 13, 0.937) !important;
    border-radius: 4px;
    transition: .4s;
  }
  .table-container {
  max-height: calc(100vh - 100px); /* Adjust as needed */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 0; /* Ensure there's no margin below */
}
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  margin-top: 0; /* Remove any top margin */
  padding: 0; /* Remove any padding */
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
.filter-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
}
.list-item {
  margin: 10px 0;
}
.wheel-container {
    text-align: left;
    margin-left: 0.5%;
  }
  .wheel-canvas {
    margin-top: 10px;
  }
  .wheel-section {
    position: relative;
    width: 500px;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .spin-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    font-size: 18px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .winner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center; /* Centers the winner-message horizontally */
    align-items: center; /* Centers the winner-message vertically */
    background-color: rgba(0, 0, 0, 0.5); /* Optional: overlay effect */
  }
  
  .winner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8); /* Dark overlay for contrast */
  z-index: 999; /* Ensure it stays on top */
}

.winner-message {
  background-color: #fff; /* White background for the message box */
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  max-width: 400px;
  width: 90%; /* Responsive width */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
}

.winner-message h2 {
  color: rgb(37, 91, 48); /* Attractive green color for congratulations */
  font-family: 'Arial', sans-serif; /* Modern font */
  margin-bottom: 15px; /* Spacing below the heading */
}

.winner-message p {
  color: #333; /* Dark grey for better readability */
  font-family: 'Verdana', sans-serif; /* Clean font */
  margin-bottom: 20px; /* Spacing below the message */
}

.close {
  background-color: rgb(37, 91, 48); /* Attractive blue color for the button */
  color: rgba(240, 206, 13, 0.937); /* White text for contrast */
  text-align: center;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s; /* Smooth transition */
}

.close:hover {
  background-color: rgb(37, 91, 48); /* Darker blue on hover */
} 
  .no-data-message {
    text-align: center;
    color: red;
    margin-top: 20px;
    font-size: 18px;
  }
  .spinning-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.card {
    border-radius: 4px; 
    background-color: #FFFFFF;
    margin-bottom: 0px;
}
  </style>